<template>
  <div>
    <div id="PengajuanManagement">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Monitoring Pengajuan</h2>
        </div>
      </div>

      <div class="row no-gutters mb-4 align-items-center">
        <!-- Kolom filter -->
        <div class="col-md-9">
          <label>Filter Berdasarkan Tanggal :</label>
          <div class="form-inline">
            <input
              name="start_date"
              type="text"
              onfocus="(this.type='date')"
              placeholder="Mulai Dari"
              class="form-control mr-2"
            />
            <input
              name="end_date"
              type="text"
              onfocus="(this.type='date')"
              placeholder="Sampai Dengan"
              class="form-control mr-2"
            />
            <b-button
              class="btn btn-custom rounded-5 btn-sm"
              @click="applyDateFilter"
              >Filter</b-button
            >
          </div>
        </div>

        <!-- Kolom total penempatan dana -->
        <div class="col-md-3 d-flex justify-content-end">
          <div class="text-right">
            <div class="font-weight-bold mt-3">Total Penempatan Dana</div>
            <div class="h5 text-success font-weight-bold">
              Rp.{{ TotalSetoran }}
            </div>
          </div>
        </div>
      </div>

      <div class="overflow-auto">
        <b-table
          id="pengajuan-table"
          responsive="true"
          :items="pengajuanItems"
          :fields="pengajuanFields"
          :current-page="currentPagePengajuan"
          :per-page="perPagePengajuan"
        >
          <template v-slot:cell(id)="data">
            <div class="d-flex align-items-center">
              <span>{{ data.item.id || "-" }}</span>
              <span
                v-if="
                  data.item &&
                  data.item.status_pengajuan_id == 11 &&
                  data.item.pengajuan_sign &&
                  data.item.pengajuan_sign.status != 'DONE'
                "
                class="badge badge-danger ml-2"
              >
                Perlu Tandatangan
              </span>
            </div>
          </template>

          <template v-slot:cell(setoran_awal)="data">
            <div class="d-flex justify-content-between">
              <span>Rp.</span>
              <span>
                {{
                  new Intl.NumberFormat("id-ID").format(
                    Number(data.item.setoran_awal)
                  )
                }}
              </span>
            </div>
          </template>

          <template v-slot:cell(jangka_waktu)="data">
            <div>
              {{
                data.item.jangka_waktu
                  ? data.item.jangka_waktu + " " + "Bulan"
                  : "-"
              }}
            </div>
          </template>

          <template v-slot:cell(biaya_jasa)="data">
            <div class="d-flex justify-content-between">
              <span>Rp.</span>
              <span>
                {{
                  data.item.biaya_jasa && !isNaN(Number(data.item.biaya_jasa))
                    ? new Intl.NumberFormat("id-ID").format(
                        Number(data.item.biaya_jasa)
                      )
                    : "-"
                }}
              </span>
            </div>
          </template>

          <template v-slot:cell(started_at)="data">
            <div>
              {{ formatTanggal(data.item.started_at) }}
            </div>
          </template>

          <template v-slot:cell(status_pengajuan_id)="data">
            <span
              v-if="data.item.status_pengajuan_id == 1"
              style="color: orange"
              >Menunggu Konfirmasi Admin</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 2"
              style="color: orange"
              >Menunggu Konfirmasi Mitra Pendukung</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 3"
              style="color: orange"
              >Menunggu Konfirmasi Mitra Utama</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 7"
              style="color: orange"
              >Menunggu Konfirmasi Pembatalan Admin</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 9"
              style="color: orange"
              >Menunggu Tanda Tangan Funder</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 11"
              style="color: orange"
              >Menunggu Tanda Tangan Mitra</span
            >

            <span
              v-else-if="data.item.status_pengajuan_id == 4"
              style="color: red"
              >Ditolak Admin</span
            >
            <span
              v-else-if="data.item.status_pengajuan_id == 5"
              style="color: red"
              >Ditolak Mitra</span
            >

            <span
              v-else-if="data.item.status_pengajuan_id == 6"
              style="color: green"
              >Disetujui Mitra</span
            >

            <span
              v-else-if="data.item.status_pengajuan_id == 8"
              style="color: red"
              >Dibatalkan</span
            >

            <span
              v-else-if="data.item.status_pengajuan_id == 10"
              style="color: gray"
              >Tidak Digunakan</span
            >

            <span v-else style="color: gray">Tidak Diketahui</span>
          </template>

          <template v-slot:cell(aksi)="data">
            <b-button
              @click="$router.push(`/show-pengajuan/${data.item.id}`)"
              type="button"
              variant="primary"
              class="btn btn-custom theme-color rounded-5"
            >
              Detail
            </b-button>
          </template>
        </b-table>
      </div>
      <h2 v-if="loaded == false" class="text-center">
        <b-spinner variant="warning"></b-spinner>
      </h2>
      <b-pagination
        align="center"
        :total-rows="rowsPengajuan"
        :per-page="perPagePengajuan"
        aria-controls="pengajuan-table"
        v-model="currentPagePengajuan"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingAgency from "../../api/marketingAgency.js";
import moment from "moment";
import "moment/locale/id";

const pengajuanFields = [
  { key: "id", label: "ID Transaksi", sortable: false },
  { key: "role", label: "Jenis Nasabah", sortable: true },
  { key: "nama_funder", label: "Nama Nasabah", sortable: true },
  { key: "nama_produk", label: "Nama Produk", sortable: true },
  { key: "sub_category", label: "Kategori Produk", sortable: true },
  { key: "setoran_awal", label: "Penempatan Dana", sortable: true },
  { key: "jangka_waktu", label: "Jangka Waktu", sortable: true },
  {
    key: "mitra_nama_organisasi_perusahaan",
    label: "Nama BPRS",
    sortable: true,
  },
  { key: "status_pengajuan_id", label: "Status Pengajuan", sortable: true },
  { key: "started_at", label: "Tanggal Aktif", sortable: true },
  { key: "biaya_jasa", label: "Ujrah", sortable: true },
];

export default {
  name: "MonitoringAgent",
  data() {
    return {
      pengajuanItems: [],
      pengajuanFields: pengajuanFields,
      perPagePengajuan: 5,
      currentPagePengajuan: 1,
      confirmStatusModal: false,
      successModal: false,
      modalTitle: "",
      textModal: "",
      modalDocTitle: "",
      changingStatus: false,
      loaded: false,
      mitra_bank_id: "",
      bankOptions: [], // Opsi bank yang tersedia
      isLoading: false,
      emailNotificationModal: false, // Control for the success email notification modal
      errorNotificationModal: false, // Control for the error notification modal
      status_pengajuan_id: null,
      pengajuan_id: null,
      confirmRejectStatusModal: false,
      rejectModal: false,
      authSignUrl: null,
      isLoadingSign: null,
      modalAuthSignUrl: false,
    };
  },
  computed: {
    rowsPengajuan() {
      return this.pengajuanItems.length;
    },
    formattedTotalSetoran() {
      if (!Array.isArray(this.pengajuanItems)) return 0;
      return this.pengajuanItems.reduce((total, item) => {
        return total + Number(item.setoran_awal || 0);
      }, 0);
    },
    TotalSetoran() {
      return new Intl.NumberFormat("id-ID").format(this.formattedTotalSetoran);
    },
  },
  mounted() {
    this.loadData();
    this.loadBankOptions(); // Memuat data bank saat komponen dimuat
  },
  methods: {
    loadData() {
      MarketingAgency.listPengajuan()
        .then((res) => {
          this.pengajuanItems = res.data.data.detail;
          console.log(this.pengajuanItems);
          this.loaded = true;
        })
        .catch((err) => console.log(err));
    },
    formatTanggal(tanggal) {
      if (!tanggal) return "-";
      return moment(tanggal).locale("id").format("DD MMMM YYYY HH:mm");
    },
    applyDateFilter() {
      return;
    },
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
  /* Mengaktifkan scroll horizontal */
  white-space: nowrap;
  /* Mencegah pembungkusan teks */
}

.b-table {
  min-width: 800px;
  /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
.btn-disabled {
  background-color: #d5a031 !important;
  color: #ffffff !important;
  opacity: 1; /* Hilangkan efek transparan */
  cursor: not-allowed; /* Tetap tidak interaktif */
  pointer-events: none; /* Tidak bisa diklik */
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/monitoring-agent.vue